<template>
    <div class="app-wrapper">
        <sidebar class="sidebar-container" />
        <div class="main-container">
            <app-main></app-main>
        </div>
    </div>
</template>

<script>
import Sidebar from './components/Sidebar/index.vue';
import AppMain from './components/AppMain.vue';

export default {
    name: 'Layout',
    components: {
        Sidebar,
        AppMain
    }
};
</script>



// WEBPACK FOOTER //
// src/layout/index.vue